import { TextProps } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';

interface TitleProps extends TextProps {
  text: string;
}

export const Title = ({ text }: TitleProps) => {
  return (
    <KText color="secondary-900" size="md-semi-bold" mb="5px">
      {text}
    </KText>
  );
};
